import { useEffect, useState } from 'react';
import React from 'react';
import { styled, withStyle } from 'baseui';
import { Spinner } from 'baseui/spinner';
export const TextBlock = styled('div', {
  whiteSpace: 'pre-wrap'
});
const ErrorBlock = withStyle(TextBlock, ({
  $theme
}) => ({
  color: $theme.colors.negative
}));
type PropsT = {
  textUrl: string;
};
export const RemoteText = ({
  textUrl
}: PropsT) => {
  const [loading, setLoading] = useState(true);
  const [text, setText] = useState('');
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLoading(true);
    (async () => {
      try {
        const response = await fetch(textUrl);
        const text = await response.text();
        setText(text);
      } catch (e) {
        console.info(e);
        setError('Failed fetching text');
      }
      setLoading(false);
    })();
  }, [textUrl]);
  if (loading) {
    return <Spinner />;
  }
  if (error) {
    return <ErrorBlock>{error}</ErrorBlock>;
  }
  return <TextBlock>{text}</TextBlock>;
};